import { render, staticRenderFns } from "./ListOficios.vue?vue&type=template&id=5dd835c9"
import script from "./ListOficios.vue?vue&type=script&lang=js"
export * from "./ListOficios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports